/* PokeVault PH: "Ask about this card" — one delegated handler for product page + collection cards.
   Copies "Hi! I'm interested in <card> — <url>" to the clipboard, then opens Messenger. */
(function () {
  var MSGR_DEFAULT = 'https://m.me/100091335556326';

  function copyText(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {}
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      return true;
    } catch (e) {}
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.pv-ask__btn') : null;
    if (!btn) return;
    e.preventDefault();

    var wrap = btn.closest('.pv-ask');
    var msgr = (wrap && wrap.getAttribute('data-msgr')) || MSGR_DEFAULT;
    var card = btn.getAttribute('data-card-title') || document.title;
    var url = btn.getAttribute('data-card-url') || window.location.href;
    var text = "Hi! I'm interested in " + card + ' — ' + url;

    var copied = copyText(text);

    // feedback: reveal the hint element if present, else briefly swap the button label
    var hint = wrap && wrap.querySelector('.pv-ask__hint');
    if (hint && copied) {
      hint.hidden = false;
    } else if (copied) {
      var label = btn.querySelector('.pv-ask__label');
      if (label && !label.dataset.reset) {
        var old = label.textContent;
        label.dataset.reset = '1';
        label.textContent = 'Copied — paste in chat';
        setTimeout(function () {
          label.textContent = old;
          delete label.dataset.reset;
        }, 2500);
      }
    }

    window.open(msgr, '_blank', 'noopener');
  });
})();
